// Shared between MenuPage (a-la-carte) and SubscriptionBuilderPage — one place
// for "what calorie/macro number does this meal type show for this member."

// quizAPI-control's mealBreakdown keys snacks "Snacks" (plural); dishes/meal
// types elsewhere use "Snack" (singular, constants/meals.js) — reconcile here.
const MEAL_BREAKDOWN_KEY = { Snack: 'Snacks' };

/** A member's per-meal targets as stored on their Client rows, or null when
 *  they haven't taken the quiz yet or are nutrition-suppressed. Callers fall
 *  back to the server's defaults (a dish's calorieInfo, or /api/menu's
 *  defaultMealTargets) when this returns null.
 *
 *  A skipped meal's row holds the default targets; they're shown as-is. */
export function quizNutritionForMealType(mealType, member) {
  if (member?.hideNutrition) return null;
  // A target the customer edited in their account panel wins over the number the
  // quiz computed (the menu cards used to keep showing the old one after an edit).
  const edited = member?.editedTargets?.[mealType];
  if (edited?.calories > 0) {
    return {
      source: 'goal',
      calories: edited.calories,
      carbsG: edited.carbsG,
      proteinG: edited.proteinG,
      fatG: edited.fatG,
      fiberG: edited.fiberG,
    };
  }
  if (!member?.hasFullQuiz) return null;
  const row = member?.profile?.rowTargets?.[mealType];
  if (row?.calories) return { source: 'goal', ...row };
  // Quiz results saved before rowTargets existed only have the breakdown.
  const real = member?.profile?.mealBreakdown?.[MEAL_BREAKDOWN_KEY[mealType] || mealType];
  if (!real?.calories) return null;
  return {
    source: 'goal',
    calories: real.calories,
    carbsG: real.carbsG,
    proteinG: real.proteinG,
    fatG: real.fatG,
    fiberG: real.fiberG,
  };
}
